<template>
  <div
    class="p-6 rounded-xl grid grid-cols-1 justify-between border border-primary-100 gap-4 md:grid-cols-4"
  >
    <div class="flex flex-col md:flex-row gap-4 md:col-span-2 items-center">
      <div class="flex flex-col justify-center">
        <BaseIcon
          name="outline_view_grid_add_thin"
          class="text-primary-700 w-12 h-12"
          size="none"
        />
      </div>
      <div>
        <div class="font-bold">
          {{ item.details.sponsor_package.name || item.entity_id }}
        </div>
        <div v-if="item.details.sponsor_package.description">
          {{ item.details.sponsor_package.description }}
        </div>
        <div
          v-if="item.details.sponsor_package.sponsor_type"
          class="text-primary-700 bold"
        >
          {{
            SPONSOR_TYPE_OPTIONS[item.details.sponsor_package.sponsor_type]
              ?.label || ''
          }}
        </div>
      </div>
    </div>
    <div class="flex gap-1 items-center whitespace-nowrap">
      <div class="md:hidden">{{ $t('tickets.price') }}:</div>
      <div class="font-bold">
        {{ formatPrice(item.amount / 100, currency, languageMap[locale]) }}
      </div>
    </div>
    <div class="flex items-center md:justify-end pt-2 md:pt-0">
      <BaseLocaleLink v-if="eventRoute" :to="eventRoute">
        <BaseButton look="border">
          {{ $t('events.go_to_event') }}
        </BaseButton>
      </BaseLocaleLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { RouteLocationRaw } from 'vue-router'
import { Currency } from '~/models/orders'
import { SPONSOR_TYPE_OPTIONS } from '~/models/companies'
import type { PackagesOrderItemResponse } from '~/models/orders'
import { useOrders } from '~/stores/orders'
import { languageMap } from '~/models/locale'

interface PropsInterface {
  item: PackagesOrderItemResponse
  currency: Currency
  isPaid: boolean
  eventRoute?: string | RouteLocationRaw
  orderId: number
}

withDefaults(defineProps<PropsInterface>(), {
  eventRoute: '',
})

const { locale } = useI18n()
const { formatPrice } = useOrders()
</script>
